module.exports = __webpack_public_path__ + "static/media/bg-banner-individuals.f283a49b.jpg";